import { motion } from "framer-motion";
import styled from "styled-components";

const bounceTransition = {
  repeat: Infinity,
  ease: "easeInOut",
  duration: 1.8,
};

const LoadingComponent = () => {
  return (
    <Wrap>
      <div style={{ display: "flex", gap: 8 }} className="inner">
        {[0, 1, 2, 3].map((i) => (
          <motion.span
            key={i}
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 0] }}
            transition={{ ...bounceTransition, delay: i * 0.2 }}
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: "#225298",
            }}
          />
        ))}
      </div>
    </Wrap>
  );
};

export default LoadingComponent;

const Wrap = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  background-color: #00000040;
  z-index: 9999;
  .inner {
    width: 10rem;
    height: 10rem;
    display: flex;
    background-color: white;
    border-radius: 100%;
    align-items: center;
    justify-content: center;
  }
`;
